// extracted by mini-css-extract-plugin
export default {"container":"ChallengesList_container__pYNKd","categorySection":"ChallengesList_categorySection__5Z+Ix","challengesContainer":"ChallengesList_challengesContainer__JAqj6"};